export default "__VITE_ASSET__ZZXSJ39r__"